type Input = {
  canTransition: boolean;
  handleTransitionEnd: (event?: TransitionEvent) => void;
  panelElement: HTMLDivElement;
};

export const setCloseAnimationStyles = (input: Input) => {
  const { canTransition, handleTransitionEnd, panelElement } = input;
  // auto の可能性に対応：現在の見かけの高さを px に固定
  panelElement.style.height =
    panelElement.style.height === "auto" || panelElement.style.height === ""
      ? `${panelElement.getBoundingClientRect().height}px`
      : panelElement.style.height;
  panelElement.style.opacity = "1";
  panelElement.style.visibility = "";

  // start 値の確定をブラウザに認識させる
  panelElement.getBoundingClientRect();

  if (!canTransition) {
    panelElement.hidden = true;
    panelElement.style.height = "0";
    panelElement.style.opacity = "0";
    return;
  }

  panelElement.addEventListener("transitionend", handleTransitionEnd);
  // 同フレームだと無音になり得る → 二重 rAF
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      panelElement.style.opacity = "0"; // 任意（フェードも入れる）
      panelElement.style.height = "0"; // ここでようやく 0 に落とす
    });
  });
};
